import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";


type Props = {
	filterName: string,
	options: string[],
}



export default /*#__PURE__*/_defineComponent({
  __name: 'filter-section',
  props: {
    filterName: {},
    options: {}
  },
  emits: ['update:selectedOptions'],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;




console.log("FilterSection mounted with", props.filterName, props.options);

if (!props.options || !props.options.length) {
	console.warn(`FilterSection "${props.filterName}" has no options.`);
}

const filterExpanded = ref(false);
const selectedOptions = ref<string[]>([]);

watch(selectedOptions, (newOptions) => {
	emit('update:selectedOptions', newOptions);
});


const __returned__ = { props, emit, filterExpanded, selectedOptions, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})